import { createFetcher } from '../../Common';

import { queryBuilder } from '../../utils';

import {
  getBaseUrl,
  PANEL_END_POINT,
  PANEL_RESOURCE_END_POINT,
  PANEL_SUGGEST_END_POINT,
} from '../../constants';

export class Panel {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Panel(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.endpoint = PANEL_END_POINT;
    this.resource_endpoint = PANEL_RESOURCE_END_POINT;
    this.suggest_endpoint = PANEL_SUGGEST_END_POINT;
    this.fetcher = fetcher;
  }

  get base_url() {
    return getBaseUrl();
  }

  async getPanelsRound(req) {
    const url = `${this.base_url + this.endpoint}/${req.positionId}`;
    const response = await this.fetcher.getData(url);
    return { data: response?.data };
  }

  async getPanelResource(req) {
    const queryString = queryBuilder(req);
    const url = `${this.base_url + this.resource_endpoint}/${queryString}`;
    const response = await this.fetcher.getData(url);
    return { data: response?.data, meta: response?.meta };
  }

  async getPanelsByIds(idsStr) {
    const url = `${this.base_url + this.resource_endpoint}/?ids=${idsStr}`;
    const response = await this.fetcher.getData(url);
    return { data: response?.data, meta: response?.meta };
  }

  async getPanelsApplication(req) {
    // add query
    let query = '';
    if (req.startTime !== '' && req?.duration !== '') {
      if (req.startTime) query += `startTime=${req?.startTime}`;
      if (req?.duration) query += `&duration=${req?.duration}`;
    }
    const url = `${this.base_url + this.suggest_endpoint}/${req.positionId}/${req.applicationId}${
      query !== '' ? `?${query}` : ''
    }`;

    const response = await this.fetcher.getData(url);
    return { data: response?.data };
  }

  async putPanel(reqParams) {
    const url = `${this.base_url + this.endpoint}/${reqParams.reqId}`;
    const response = await this.fetcher.putData(url, reqParams.reqBody);
    return response?.data;
  }

  async putPanelResource(reqParams) {
    const url = `${this.base_url + this.resource_endpoint}/${reqParams.reqId}`;
    const response = await this.fetcher.putData(url, reqParams.reqBody);
    return response?.data;
  }

  async postPanel(reqBody) {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.postData(url, reqBody);
    return response?.data;
  }

  async postResourcePanel(reqBody) {
    const url = `${this.base_url}${this.resource_endpoint}`;
    const response = await this.fetcher.postData(url, reqBody);
    return response?.data;
  }

  async deletePanelResourceById(req) {
    const url = `${this.base_url + this.resource_endpoint}/${req.reqId}`;
    const response = await this.fetcher.deleteData(url, req.reqBody);
    return response;
  }

  async deletePanelById(req) {
    const url = `${this.base_url + this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.deleteData(url, req.reqBody);
    return response;
  }
}

export const createPanel = () => Panel.getInstance();
